<div class="v4-layout-block">
  <div class="v4-layout-block-title">
    {{ "word.date" | translate }}
    <!-- Dates -->
  </div>
  <div class="v4-layout-block-content">
    <nz-tabset
      [nzTabPosition]="'top'"
      [nzTabBarGutter]="6"
      [(nzSelectedIndex)]="tabIndex"
      (nzSelectedIndexChange)="onTabChange()"
    >
      <nz-tab nzTitle="{{ 'house_price.click_date' | translate }}"> </nz-tab>
      <nz-tab nzTitle="{{ 'house_price.consecutive_date' | translate }}"> </nz-tab>
    </nz-tabset>
    <div class="pt-[30px]">
      <!-- <div class="select-dates-info">{{ selectedDatesInfo }}</div> -->
      <div class="calendar">
        <host-base-calendar [continuous]="isContinuous" [(ngModel)]="selectedDates"></host-base-calendar>
      </div>
      <div class="v4-filter-list">
        <!-- <div class="label">{{ "house_price.rapid_positioning" | translate }}</div> -->
        <div class="v4-filter-item" *ngFor="let h of holidayList" (click)="onClickHoliday(h)">
          <div class="v4-filter-selectable">
            {{ h.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="v4-layout-block" *ngIf="showChannel">
  <div class="v4-layout-block-title">
    {{ "operate.field.channel" | translate }}
    <!-- Channels -->
  </div>
  <div class="v4-layout-block-content">
    <div class="channel-picker">
      <host-simple-multi-select
        unitKey="渠道"
        size="large"
        [(ngModel)]="selectedChannels"
        [listOfOption]="channelOptions"
      ></host-simple-multi-select>
    </div>
  </div>
</div>
<div class="footer flex flex-row items-center justify-between">
  <div class="ml-auto">
    <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
    <button nz-button nzSize="large" nzType="primary" class="btn" (click)="onConfirm()">
      {{ "word.confirm" | translate }}
    </button>
  </div>
</div>
